import { render } from "./AppPage.vue.js?vue&type=template&id=46d0670c!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppPage.vue?vue&type=template&id=46d0670c"
import script from "./AppPage.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/AppPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46d0670c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46d0670c', __exports__)) {
    api.reload('46d0670c', __exports__)
  }
  
  module.hot.accept("./AppPage.vue.js?vue&type=template&id=46d0670c!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppPage.vue?vue&type=template&id=46d0670c", () => {
    api.rerender('46d0670c', render)
  })

}


export default __exports__